// extracted by mini-css-extract-plugin
export default {"screen-item":"ScreenItem_screen-item__1KlPp","screen-item__link":"ScreenItem_screen-item__link__TdXXn","playlist-remainder":"ScreenItem_playlist-remainder__H9v5n"};